import { useEffect, useState } from 'react';

/**
 * Хук, который отложенно обновляет значение.
 *
 * @typeParam T - Тип значения.
 * @param value - Обновляемое значение.
 * @param delay - Время в миллисекундах.
 * @returns Отложенное значение.
 */
export const useDebounce = <T>(value: T, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};
